import {
  formatPersonaApellidoNombre,
  sortPersonasByApellidoNombre,
} from "../../../utils/personaDisplay.js"

export const getPasajeroNombrePdf = (pasajero = {}) => formatPersonaApellidoNombre(pasajero)

export const sortPasajerosPdf = (pasajeros = []) => sortPersonasByApellidoNombre(pasajeros)
